import moment from 'moment';

export class Procall {
  arcAngelId: string;
  name: string;
  profileId: string;
  status: string;
  created: string;
  updated: string;
  parentId: string;

  constructor(
    id: string,
    profileId: string,
    status: string,
    created: string,
    updated: string,
    parentId: string
  ) {
    this.arcAngelId = id;
    this.name = id;
    this.profileId = profileId;
    this.status = status;
    this.created = created;
    this.updated = updated;
    this.parentId = parentId;
  }

  getId(): string {
    return this.arcAngelId;
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): void {
    this.name = name;
  }

  getProfileId(): string {
    return this.profileId;
  }

  setProfileId(profileId: string): void {
    this.profileId = profileId;
  }

  getStatus(): string {
    return this.status;
  }

  setStatus(status: string): void {
    this.status = status;
  }

  getIsPending(): boolean {
    return this.status === 'pending';
  }

  getIsOpen(): boolean {
    return this.status === 'open';
  }

  getIsResolved(): boolean {
    return this.status === 'resolved';
  }

  getCreatedAtDate(): string {
    return this.created;
  }

  getTimestamp(): string {
    return this.created;
  }

  getFormattedCreatedAtDate(): string {
    return moment(this.created).fromNow();
  }

  getUpdatedAtDate(): string {
    return this.updated;
  }

  setUpdatedAtDate(updated: string): void {
    this.updated = updated;
  }

  update(procallObj: Procall): void {
    this.updated = procallObj.getUpdatedAtDate();
    this.status = procallObj.getStatus();
  }
}